import Vue from "vue";

export default {

    defaultTheme () {
        return {
            dark_mode: false,
            neutral_color: "#d5514b"
        }
    },

    init () {
        let theme = localStorage.getItem('theme') ? JSON.parse(localStorage.getItem('theme')) : this.defaultTheme()
        let name = theme.dark_mode ? "dark" : "default"
        Vue.http.get('/static/themes/' + name + '.json').then(response => {
            this.setMode(JSON.parse(response.bodyText))
            if(theme.neutral_color){
                this.setNeutralColor(theme.neutral_color)
            }
        })
    },

    setMode (theme) {
        let root = document.documentElement.style;
        for(let name in theme){
            root.setProperty(name, theme[name])
        }
    },

    setNeutralColor (hex) {
        let root = document.documentElement.style;

        root.setProperty('--neutral-color', hex)
        root.setProperty('--neutral-color-light-1', color.lighter(hex, 2))
        root.setProperty('--neutral-color-dark-1', color.darkness(hex, 2))
    }

}

let ihCode = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']
let hiCode = {0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8', 9: '9', A: '10', B: '11', C: '12', D: '13', E: '14', F: '15', a: '10', b: '11', c: '12', d: '13', e: '14', f: '15'}

let convert = {

    hexToInt (hex) {
        return hiCode[hex]
    },

    IntToHex (int) {
        return ihCode[int]
    }

}

let color = {

    lighter(hex, power) {
        let base = hex.substr(1, 6).split('')
        let finalHex = '#';
        base.forEach(function(element){
            let current = parseInt(convert.hexToInt(element))
            if(current + power > 15){
                current = 15
            }else{
                current = parseInt(current) + parseInt(power)
            }
            finalHex += convert.IntToHex(current)
        })
        return finalHex
    },

    darkness(hex, power) {
        let base = hex.substr(1, 6).split('')
        let finalHex = '#';
        base.forEach(function(element){
            let current = parseInt(convert.hexToInt(element))
            if(current - power < 0){
                current = 0
            }else{
                current = parseInt(current) - parseInt(power)
            }
            finalHex += convert.IntToHex(current)
        })
        return finalHex
    }

}


// WEBPACK FOOTER //
// ./src/plugins/theme.js